import * as React from 'react';
import { cn } from './utils';

/**
 * GlassCard — standard translucent card surface (radius 20px).
 * Default container for grouped content: filters, tables, summaries.
 *
 * GlassPanel — larger, more elevated surface (radius 24px) with stronger blur.
 * Use for hero widgets, primary operational context, or page-level panels.
 *
 * Both consume the semantic `app.*` surface tokens (light: white-on-light haze;
 * dark: white-on-dark glass). The shadcn `bg-card/60`/`bg-glass/55` pattern
 * was inverted in dark mode (dark color × dark page → invisible widget); the
 * `bg-app-surface` token already encodes the right alpha per theme so no `/X`
 * modifier is needed.
 */

const GLASS_CARD_BASE =
  'rounded-xl border border-app-border bg-app-surface backdrop-blur-xl text-app-text';

const GLASS_PANEL_BASE =
  'rounded-2xl border border-app-border bg-app-elevated backdrop-blur-2xl text-app-text';

export const GlassCard = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn(GLASS_CARD_BASE, className)} {...props} />
  ),
);
GlassCard.displayName = 'GlassCard';

export const GlassPanel = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn(GLASS_PANEL_BASE, className)} {...props} />
  ),
);
GlassPanel.displayName = 'GlassPanel';
